var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 125,
    viewBox: "0 0 160 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5169 104.287C106.501 104.287 126.757 84.0702 126.757 59.0436C126.757 34.017 106.412 13.7998 81.5169 13.7998C56.5323 13.7998 36.2769 34.017 36.2769 59.0436C36.2769 84.0702 56.5323 104.287 81.5169 104.287Z",
    fill: "#FFDFE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.455 29.4747C125.476 29.4747 127.114 27.836 127.114 25.8232C127.114 23.8104 125.476 22.1716 123.455 22.1716C121.435 22.1716 119.797 23.8104 119.797 25.8232C119.797 27.836 121.435 29.4747 123.455 29.4747Z",
    fill: "#F1F3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.809 15.225C130.189 15.225 131.307 14.1118 131.307 12.7313C131.307 11.3509 130.189 10.2375 128.809 10.2375C127.429 10.2375 126.311 11.3509 126.311 12.7313C126.311 14.1118 127.429 15.225 128.809 15.225Z",
    fill: "#F6F7FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5292 35.7094C33.9087 35.7094 35.0277 34.5962 35.0277 33.2157C35.0277 31.8352 33.9087 30.7219 32.5292 30.7219C31.1497 30.7219 30.0308 31.8352 30.0308 33.2157C30.0308 34.5962 31.1497 35.7094 32.5292 35.7094Z",
    fill: "#F6F7FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2709 105C48.8336 105 50.9109 102.925 50.9109 100.369C50.9109 97.8124 48.8336 95.7373 46.2709 95.7373C43.7082 95.7373 41.6309 97.8124 41.6309 100.369C41.6309 102.925 43.7082 105 46.2709 105Z",
    fill: "#F6F7FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30_17041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 71.1563C138 82.6721 128.675 91.9792 117.046 91.9792C116.845 91.9792 115.141 91.9792 102.608 91.9792C93.8861 91.9792 79.95 91.9792 57.6923 91.9792H47.0649C33.1289 92.2731 22 81.1669 22 67.7541C22 54.2522 33.2288 43.0393 47.3656 43.7428C59.4966 5.91798 115.041 11.2172 119.752 50.3424C130.18 51.6427 138 60.451 138 71.1563Z",
    fill: "url(#paint0_linear_30_17041)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.046 91.9793C128.575 91.9793 138 82.6722 138 71.1564C138 59.6496 128.575 50.3425 117.046 50.3425C105.515 50.3425 96.0918 59.6496 96.0918 71.1564C96.0918 82.6722 105.515 91.9793 117.046 91.9793Z",
    fill: "url(#paint1_linear_30_17041)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8572 92.1748C103.411 92.1748 120.154 75.5647 120.154 55.0447C120.154 34.5336 103.411 17.9233 82.8572 17.9233C62.3038 17.9233 45.5605 34.5336 45.5605 55.0447C45.5605 75.5647 62.2039 92.1748 82.8572 92.1748Z",
    fill: "url(#paint2_linear_30_17041)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05 51.02C75.05 52.69 73.7 54.05 72.03 54.05C70.35 54.05 69 52.69 69 51.02C69 49.35 70.35 48 72.03 48C73.7 48 75.05 49.35 75.05 51.02Z",
    fill: "#AAB2C5",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9099 51.02C91.9099 52.69 90.5599 54.05 88.8899 54.05C87.2199 54.05 85.8599 52.69 85.8599 51.02C85.8599 49.35 87.2199 48 88.8899 48C90.5599 48 91.9099 49.35 91.9099 51.02Z",
    fill: "#AAB2C5",
    stroke: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M87.85 69.1301H73.0599C70.7099 69.1301 69.4 66.5001 70.78 64.5701C71.82 63.1201 73.13 61.94 74.65 61.04C76.38 60.08 78.38 59.52 80.46 59.52C82.95 59.52 85.23 60.2801 87.16 61.6001C88.34 62.4301 89.37 63.3901 90.2 64.5701C91.52 66.5001 90.2 69.1301 87.85 69.1301Z",
    fill: "#D6DCE8",
    stroke: "#D6DCE8",
    strokeWidth: 1.7035,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6401 69.1304H75.3401C75.2701 68.9904 75.2701 68.8502 75.3401 68.7202C76.1001 66.5702 78.1102 65.0503 80.5302 65.0503C82.9502 65.0503 84.9501 66.5702 85.7101 68.7202C85.7101 68.8502 85.7101 68.9904 85.6401 69.1304Z",
    fill: "#AAB2C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1598 62.2903V62.8403C87.1598 63.2603 86.8197 63.5303 86.4697 63.5303H75.4098C74.9998 63.5303 74.7197 63.1903 74.7197 62.8403V61.7402C76.4497 60.7702 78.4498 60.2202 80.5298 60.2202C82.9398 60.2202 85.2298 60.9803 87.1598 62.2903Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5027 20.9695C40.7124 20.1502 41.5485 19.6514 42.3712 19.8652L48.19 21.3346C49.0127 21.5484 49.5097 22.3857 49.3009 23.205C49.0912 24.0244 48.2551 24.5231 47.4324 24.3094L41.6145 22.8398C40.7909 22.6261 40.2939 21.7889 40.5027 20.9695Z",
    fill: "#F13F5E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.447 4.64441C46.1493 4.16347 47.1049 4.35056 47.5823 5.04525L54.5369 15.2785C55.0134 15.9732 54.8305 16.9262 54.1283 17.4071C53.426 17.8792 52.4704 17.701 51.993 16.9974L45.0383 6.77301C44.561 6.06942 44.7439 5.11644 45.447 4.64441Z",
    fill: "#F13F5E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3481 0.0309001C59.1806 -0.138319 59.9899 0.404941 60.155 1.23322L62.5589 13.3635C62.724 14.1918 62.1823 15.0023 61.3498 15.1626C60.5164 15.3318 59.7079 14.7886 59.5429 13.9603L57.139 1.82998C56.9739 1.0017 57.5155 0.191213 58.3481 0.0309001Z",
    fill: "#F13F5E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.634 30.2569C129.249 31.9219 128.672 33.5221 127.966 34.9929C126.107 38.4431 123.349 41.255 119.887 42.9847C116.295 44.8347 112.062 45.473 107.766 44.6405C97.7615 42.5315 91.2847 32.8191 93.4009 22.7829C95.5171 12.7467 105.201 6.29032 115.269 8.3993C118.86 9.16705 122.003 10.8967 124.632 13.3849C128.992 17.8619 130.852 24.1889 129.634 30.2569Z",
    fill: "#F13F5E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 17.1562C109.652 17.1562 107.845 17.7043 106.309 18.731C104.772 19.7577 103.575 21.217 102.868 22.9243C102.16 24.6316 101.975 26.5104 102.336 28.3229C102.696 30.1354 103.586 31.8003 104.893 33.107C106.2 34.4138 107.865 35.3037 109.677 35.6642C111.49 36.0247 113.368 35.8397 115.076 35.1325C116.783 34.4253 118.242 33.2277 119.269 31.6911C120.296 30.1545 120.844 28.348 120.844 26.5C120.839 24.0233 119.853 21.6495 118.102 19.8982C116.351 18.147 113.977 17.161 111.5 17.1562ZM110.781 22.1875C110.781 21.9969 110.857 21.8141 110.992 21.6793C111.127 21.5445 111.309 21.4688 111.5 21.4688C111.691 21.4688 111.873 21.5445 112.008 21.6793C112.143 21.8141 112.219 21.9969 112.219 22.1875V27.2188C112.219 27.4094 112.143 27.5922 112.008 27.727C111.873 27.8618 111.691 27.9375 111.5 27.9375C111.309 27.9375 111.127 27.8618 110.992 27.727C110.857 27.5922 110.781 27.4094 110.781 27.2188V22.1875ZM111.5 31.5312C111.287 31.5312 111.078 31.468 110.901 31.3496C110.724 31.2311 110.586 31.0627 110.504 30.8657C110.422 30.6687 110.401 30.4519 110.443 30.2428C110.484 30.0337 110.587 29.8416 110.738 29.6908C110.888 29.54 111.081 29.4373 111.29 29.3957C111.499 29.3541 111.716 29.3755 111.913 29.4571C112.11 29.5387 112.278 29.6769 112.396 29.8542C112.515 30.0314 112.578 30.2399 112.578 30.4531C112.578 30.7391 112.465 31.0133 112.262 31.2155C112.06 31.4177 111.786 31.5312 111.5 31.5312Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30_17041",
    x: 0,
    y: 7.0144,
    width: 160,
    height: 117.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.25098 0 0 0 0 0.266667 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_17041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_17041",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_17041",
    x1: 80,
    y1: 48.579,
    x2: 79.9627,
    y2: 92.7807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_17041",
    x1: 93.8619,
    y1: 45.8627,
    x2: 112.399,
    y2: 66.1771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_17041",
    x1: 42.0681,
    y1: 38.0158,
    x2: 71.3309,
    y2: 49.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkNotAvailable);
export default __webpack_public_path__ + "static/media/link_not_available.5fc105bc6b3834428607b5d08e4c9af4.svg";
export { ForwardRef as ReactComponent };